<div>
  <div class="mb-5x">
    <div class="d-flex justify-content-between">
      <h2>{{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.TITEL' | translate }}</h2>

      <common-ui-daten-uebernahme (picked)="onWirtschaftsJahrPicked()" [itemTemplate]="datenuebernahmeGewinnermittlung"
                                  [items]="wirtschaftsJahrStammdaten" [readonly]="readonly"
                                  context="Gewinnermittlung"></common-ui-daten-uebernahme>
    </div>
    <div class="col-sm-12 col-lg-12 p-0 mb-3x mt-1x">
      <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.HINWEIS' | translate"
                      type="info">
      </common-ui-card>
    </div>

    <common-ui-gewinnermittlung
      [(data)]="data"
      [readonly]="readonly">
    </common-ui-gewinnermittlung>
  </div>
</div>

<ng-template #datenuebernahmeGewinnermittlung let-item="item">
  <div *ngIf="item.isAbweichend">
    <h4
      class="list-group-item-heading">{{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.STAMMDATEN_NONSTANDARD_YEAR_TITEL' | translate }}</h4>
    <p class="list-group-item-text"> {{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.BEGINN' | translate }} {{item?.von}}</p>
  </div>
  <div *ngIf="!item.isAbweichend">
    <h4
      class="list-group-item-heading">{{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.STAMMDATEN_STANDARD_YEAR_TITEL' | translate }}</h4>
  </div>
</ng-template>
